<template>
  <div class="w-full bg-tw-cream text-left font-inter">
    <LandingHero heading-tag="p" />
    <main class="mx-auto max-w-[1280px] px-6 pb-24 pt-16 text-tw-ink md:px-[76px] md:pb-[200px] md:pt-[89px]">
      <h1 ref="heading" tabindex="-1" class="text-4xl tracking-[-0.02em] text-black focus:outline-none md:text-[45px] md:leading-[1.2]">
        <slot name="title" />
      </h1>
      <div class="mt-8 max-w-[1093px] text-xl leading-8 md:text-[25px]">
        <slot />
      </div>
    </main>
    <LandingFooter />
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { useRouter } from 'vue-router'

  import LandingHero from './LandingHero.vue'
  import LandingFooter from './LandingFooter.vue'

  const heading = ref<HTMLHeadingElement | null>(null)
  const router = useRouter()

  // After in-app navigation, move focus to the new page title so screen readers announce it
  onMounted(() => {
    if (router.options.history.state.back) heading.value?.focus()
  })
</script>
